var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',[_c('feather-icon',{attrs:{"badge-classes":"bg-danger","size":"21","icon":"ActivityIcon"},on:{"click":function($event){return _vm.$router.push({name: 'pages-user-dashboard'})}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }